// These were the custom payouts which have end dates in 2022
// But were issued in 2023 so they will have payout reports generated via Invoicing service and MPS
export const PAYOUTS_ISSUED_IN_2023_WITH_2022_INTERVAL = [
  '63ada0c7d9417d4255f977e0',
  '63b3d983d9417d4255f97f51',
  '63b42fbd72317f54c471b71a',
  '63b42fbed9417d4255f98002',
  '63b42fd00c0ca930643e6a7f',
  '63b42fbbd9417d4255f97ffe',
  '63b42fc372317f54c471b725',
  '63b42fd20c0ca930643e6a83',
  '63b42fbf72317f54c471b71e',
  '63b2a586d9417d4255f97d8e',
];
